import React, { useState , useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import TeachHeader from './TeachHeader'
import { Link , useParams } from 'react-router-dom';
import axios from '../Axiosinstance'
import { TableBody, TableCell, TableHead, TableRow , TableContainer} from '@mui/material';
import Table from '@mui/material/Table';
import Paper from '@mui/material/Paper';


const styles = {
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 20px',
    backgroundColor: '#abdeda',
    marginBottom: '20px',
  },
  logo: {
    fontSize: '34px',
    fontWeight: 'bold',
    marginRight: '20px',
  },
  headerList: {
    display: 'flex',
    listStyle: 'none',
    padding: 0,
  },
  headerListItem: {
    marginLeft: '20px',
  },
  navigationDropdown: {
    width: 120,
    height: 50,
    display: 'flex',
    backgroundColor: '#abdeda',
    justifyContent: 'center',
    alignItems: 'center',
    textDecoration: 'none',
    color: 'black',
    fontWeight: 'bold',
    fontSize: '16px',
    margin: '0 10px',
  },
  navigationButton: {
    width: 120,
    height: 50,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textDecoration: 'none',
    color: 'white',
    fontWeight: 'bold',
    backgroundColor:'#03396c',
    fontSize: '16px',
    margin: '0 10px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  },
 
 


 
};






const Container = () => {
  const { batchId } = useParams();
  const [batchDetails, setBatchDetails] = useState(null);
  const [students, setStudents] = useState([]);


  useEffect(() => {
    // Fetch batch details
    const fetchBatchDetails = async () => {
      try {
        const response = await axios.get(`batch/${batchId}`);
        setBatchDetails(response.data);
      } catch (error) {
        console.error('Error fetching batch details:', error);
      }
    };


    const fetchStudents = async () => {
      try {
        const response = await axios.get('students');
        setStudents(response.data);
      } catch (error) {
        console.error('Error fetching student data:', error);
      }
    };


    fetchBatchDetails();
    fetchStudents();
  }, [batchId]);


  if (!batchDetails) {
    return <p>Loading...</p>;
  }
  return (
    <div className="containerw  " style={{ marginTop: '5%', marginLeft: '1%'}}>
    <div className="row">
      <div className="col-md-4" >
        <div className="container-content">
          <p className="paragraph">Course:{batchDetails.course}</p>
          <p className="paragraph">Course Date:{batchDetails.date}</p>
          <p className="paragraph">Trainers:{batchDetails.trainers}</p>
        </div>
      </div>


      <div className="col-md-4">
        <div className="container-content">
          <p className="paragraph">Batch:{batchDetails.batchcode}</p>
          <p className="paragraph">Student Enrolled:{batchDetails.course}</p>
          <p className="paragraph">Assessors:{batchDetails.assessors}</p>
        </div>
      </div>
    </div>
  </div>
  );
};




const App = () => {
  const { batchId } = useParams();
  const [data, setData] = useState([]);
  const [sIdArray, setSIdArray] = useState([]);
  const [studentDetails, setStudentDetails] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortedColumn, setSortedColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState('asc'); // 'asc' or 'desc'
  const [studentsPerPage, setStudentsPerPage] = useState(5); // Default to 5 students per page
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredStudentDetails, setFilteredStudentDetails] = useState([]);


  useEffect(() => {
    // Fetch data from the 'manages' endpoint using Axios
    axios
      .get(`manages`)
      .then((response) => {
        const result = response.data;
        const filteredData = result.filter((item) => item.batch_id == batchId);
        setData(filteredData);
 
        // Extract sId values and store them in an array
        const sIds = filteredData.map((item) => item.sId);
        setSIdArray(sIds);
 
        // Fetch student details based on sId values
        fetchStudentDetails(sIds);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  }, [batchId]);
 


  useEffect(() => {
    // console.log("Search query changed:", searchQuery);
 
    let filteredStudents;
    if (searchQuery === '') {
      // If the search query is empty, display all student details
      filteredStudents = studentDetails;
    } else {
      filteredStudents = studentDetails.filter((student) =>
        Object.values(student)
          .join(' ')
          .toLowerCase()
          .includes(searchQuery.toLowerCase())
      );
    }
 
    // console.log("Filtered students:", filteredStudents);
 
    // Check if the filtered results are different from the current state
    if (!areArraysEqual(filteredStudents, filteredStudentDetails)) {
      // Update the state only if the filtered results have changed
      setFilteredStudentDetails(filteredStudents);
      // console.log("Filtered student details updated:", filteredStudents);


    }
  }, [searchQuery, studentDetails]);
 
 
  // Utility function to compare two arrays
  function areArraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) {
      return false;
    }
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) {
        return false;
      }
    }
    return true;
  }
 


  const fetchStudentDetails = async (sIds) => {
    // Convert sIds to numbers and store them in an array
    const sIdNumbers = sIds.map((sId) => Number(sId));
 
    try {
      // Fetch student details based on sIdNumbers using Axios
      const response = await axios.get('students');
      const studentData = response.data;
 
      // Filter student data based on matching IDs
      const filteredStudents = studentData.filter((student) =>
        sIdNumbers.includes(student.id)
       
      );
 
      setStudentDetails(filteredStudents);
      // console.log(filteredStudents)
    } catch (error) {
      console.error('Error fetching student details:', error);
    }
  };


 
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    // console.log("Search query updated:", event.target.value);
  };
 


  const handleSort = (column) => {
    if (column === sortedColumn) {
      // Toggle sort direction
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      // Set a new column for sorting
      setSortedColumn(column);
      setSortDirection('asc');
    }
  };


  const sortedStudentDetails = [...studentDetails];


  if (sortedColumn) {
    // Sort the data based on the sorted column and direction
    sortedStudentDetails.sort((a, b) => {
      const aValue = a[sortedColumn];
      const bValue = b[sortedColumn];
 
      if (typeof aValue === 'string' && typeof bValue === 'string') {
        // Compare as strings if both values are strings
        if (sortDirection === 'asc') {
          return aValue.localeCompare(bValue);
        } else {
          return bValue.localeCompare(aValue);
        }
      } else {
        // Handle other data types (e.g., numbers)
        if (sortDirection === 'asc') {
          return aValue < bValue ? -1 : 1;
        } else {
          return aValue > bValue ? -1 : 1;
        }
      }
    });
  }
  const renderSortArrow = (column) => {
    if (column === sortedColumn) {
      return sortDirection === 'asc' ? '↑' : '↓';
    }
    return null;
  };


  const handlePageChange = (page) => {
    setCurrentPage(page);
  };


  const handlePerPageChange = (event) => {
    const perPage = parseInt(event.target.value, 10);
    setStudentsPerPage(perPage);
    setCurrentPage(1);
  };


 


  const startIndex = (currentPage - 1) * studentsPerPage;
const endIndex = startIndex + studentsPerPage;
const studentsToDisplay = filteredStudentDetails.slice(startIndex, endIndex);


  return (
    <div >


      <TeachHeader />
     


      <div>
     
      <div className="containerw" style={{ maxWidth: '1200px' }}>
      <Container />
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
       
      <input
          type="text"
          placeholder="Search "
          value={searchQuery}
          onChange={handleSearchChange}
          style={{
              padding: '8px 12px',
              border: '1px solid #ccc',
              borderRadius: '4px',
              float:'left',
              fontSize: '16px',
            }}
        />
       
     
        <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow style={styles.tableHeader}>
            <TableCell
                style={{ ...styles.tableCell, ...styles.sortableHeader }}
                onClick={() => handleSort('fullname')}
              >
                Name {renderSortArrow('fullname')}
              </TableCell>
           
              <TableCell
                style={{ ...styles.tableCell, ...styles.sortableHeader }}
                onClick={() => handleSort('id')}
              >
                Id {renderSortArrow('id')}
              </TableCell>
              <TableCell
                style={{ ...styles.tableCell, ...styles.sortableHeader }}
                onClick={() => handleSort('email')}
              >
                Email {renderSortArrow('email')}
              </TableCell>
              <TableCell
                style={{ ...styles.tableCell, ...styles.sortableHeader }}
                onClick={() => handleSort('phone')}
              >
                Phone {renderSortArrow('phone')}
              </TableCell>
              <TableCell
                style={{ ...styles.tableCell, ...styles.sortableHeader }}
                onClick={() => handleSort('gender')}
              >
                Gender {renderSortArrow('gender')}
              </TableCell>
              <TableCell
                style={{ ...styles.tableCell, ...styles.sortableHeader }}
                onClick={() => handleSort('dob')}
              >
                DOB {renderSortArrow('dob')}
              </TableCell>
              <TableCell
                style={{ ...styles.tableCell, ...styles.sortableHeader }}
                onClick={() => handleSort('address')}
              >
                Address {renderSortArrow('address')}
              </TableCell>
              <TableCell
                style={{ ...styles.tableCell, ...styles.sortableHeader }}
                onClick={() => handleSort('postalcode')}
              >
                Postal Code {renderSortArrow('postalcode')}
              </TableCell>
              <TableCell
                style={{ ...styles.tableCell, ...styles.sortableHeader }}
                onClick={() => handleSort('race')}
              >
                Race {renderSortArrow('race')}
              </TableCell>
              <TableCell
                style={{ ...styles.tableCell, ...styles.sortableHeader }}
                onClick={() => handleSort('eduction')}
              >
                Eduction {renderSortArrow('eduction')}
              </TableCell>
              <TableCell
                style={{ ...styles.tableCell, ...styles.sortableHeader }}
                onClick={() => handleSort('employmentstatus')}
              >
                Employment Status {renderSortArrow('employmentstatus')}
              </TableCell>
              <TableCell
                style={{ ...styles.tableCell, ...styles.sortableHeader }}
                onClick={() => handleSort('salary')}
              >
                Salary {renderSortArrow('salary')}
              </TableCell>
              <TableCell
                style={{ ...styles.tableCell, ...styles.sortableHeader }}
                onClick={() => handleSort('companyname')}
              >
                Company {renderSortArrow('companyname')}
              </TableCell>
              <TableCell
                style={{ ...styles.tableCell, ...styles.sortableHeader }}
                onClick={() => handleSort('designation')}
              >
                Designation {renderSortArrow('designation')}
              </TableCell>
              <TableCell
                style={{ ...styles.tableCell, ...styles.sortableHeader }}
                onClick={() => handleSort('corporatecompanysponsored')}
              >
                WTS {renderSortArrow('corporatecompanysponsored')}
              </TableCell>            </TableRow>
          </TableHead>
          <TableBody>
          {studentsToDisplay.map((student, index) => (
              <TableRow key={index}>
                <TableCell style={styles.tableCell}>{student.fullname}</TableCell>
                <TableCell style={styles.tableCell}>{student.id}</TableCell>
                <TableCell style={styles.tableCell}>{student.email}</TableCell>
                <TableCell style={styles.tableCell}>{student.phone}</TableCell>
                <TableCell style={styles.tableCell}>{student.gender}</TableCell>
                <TableCell style={styles.tableCell}>{student.dob}</TableCell>
                <TableCell style={styles.tableCell}>{student.address}</TableCell>
                <TableCell style={styles.tableCell}>{student.postalcode}</TableCell>
                <TableCell style={styles.tableCell}>{student.race}</TableCell>
                <TableCell style={styles.tableCell}>{student.eduction}</TableCell>
                <TableCell style={styles.tableCell}>{student.employmentstatus}</TableCell>
                <TableCell style={styles.tableCell}>{student.salary}</TableCell>
                <TableCell style={styles.tableCell}>{student.companyname}</TableCell>
               
                <TableCell style={styles.tableCell}>{student.designation}</TableCell>
                <TableCell style={styles.tableCell}>{student.corporatecompanysponsored}</TableCell>


              </TableRow>
            ))}
            </TableBody>
         </Table>
         </TableContainer>  
         
 
</Paper>
      </div>
      </div>
     
      </div>
  );
};






export default App;



